module.exports = __webpack_public_path__ + "media/images/slider-big-arrow-left-08284843f662925150cebdb07daaec5d.png";